dmx.Attribute("class", "mounted", function (node, attr) {
  this.$watch(attr.value, value => {
    node.classList[value ? "add" : "remove"](attr.argument);
  });
});
